/**
 * URL encode / decode — pure.
 *
 * Component mode uses `encodeURIComponent` / `decodeURIComponent` (encodes
 * reserved characters like &=?/); full-URI mode uses `encodeURI` / `decodeURI`
 * (leaves URL structure intact). Decoding malformed percent-escapes throws a
 * URIError, surfaced as an error rather than crashing.
 */

export interface UrlResult {
  ok: boolean;
  output?: string;
  error?: string;
}

export function encodeUrl(text: string, fullUri = false): UrlResult {
  try {
    return {
      ok: true,
      output: fullUri ? encodeURI(text) : encodeURIComponent(text),
    };
  } catch (e) {
    return {
      ok: false,
      error: e instanceof Error ? e.message : "Encode failed",
    };
  }
}

export function decodeUrl(text: string, fullUri = false): UrlResult {
  if (text === "") return { ok: true, output: "" };
  try {
    return {
      ok: true,
      output: fullUri ? decodeURI(text) : decodeURIComponent(text),
    };
  } catch {
    return { ok: false, error: "Invalid percent-encoding" };
  }
}
